app.component('eatlifeCheckResult', {
    templateUrl: 'app/eatlife/eatlife_check_result.html',
    controller: function ( $routeParams, selfcheckService, localStorageAccess ) {
        var $ctrl = this;
        $ctrl.$onInit = function () {
            $ctrl.nowDate = moment().format("YYYY.MM.DD");
            //評価結果
            var gradeComment = selfcheckService.gradeComment;
            var score = $routeParams.gradescore;
            //スコアに対応した評価コメントを取得
            for(var i = gradeComment.length-1; i >= 0; i--) {
                if ( score >= gradeComment[i].minScore ) {
                    comment = gradeComment[i].text;
                    break;
                }
            }
            $ctrl.result = {
                "date": moment().format("YYYY.MM.DD"),
                "score": score,
                "comment": comment,
            }
            // 結果をローカルストレージへ保存
            localStorageAccess.setData("eatlife", { "last": $ctrl.result.date, "score" : $ctrl.result.score });
        };
    }
});
